import { CROSS_TAB_SESSION_ACTIVE } from "@constants/storage"

const CHANNEL_NAME = "roopairs-browser-channel-tab-check"

const RESPONSE_TIMEOUT = 100

/* ----------------------------------------------------------------
 * Messages & type guards
 * ---------------------------------------------------------------- */

export type PingMessage = { type: "PING" }
export type PongMessage = { type: "PONG" }

type ChannelMessage = PingMessage | PongMessage

interface InitOptions {
    onNewSession?(): void
    onExistingSession?(): void
}

const isChannelMessage = (data: unknown): data is ChannelMessage =>
    typeof data === "object" && data !== null && "type" in data

const isPingMessage = (data: unknown): data is PingMessage => isChannelMessage(data) && data.type === "PING"

const isPongMessage = (data: unknown): data is PongMessage => isChannelMessage(data) && data.type === "PONG"

export function initCrossTabSession(options: InitOptions = {}) {
    const channel = new BroadcastChannel(CHANNEL_NAME)
    let received = false

    const handleResponse = (event: MessageEvent) => {
        if (isPongMessage(event.data)) {
            received = true
            sessionStorage.setItem(CROSS_TAB_SESSION_ACTIVE, "true")
            options.onExistingSession?.()
            channel.removeEventListener("message", handleResponse)
        }
    }

    const respondToPing = (event: MessageEvent) => {
        if (isPingMessage(event.data)) {
            channel.postMessage({ type: "PONG" })
        }
    }

    const isActive = sessionStorage.getItem(CROSS_TAB_SESSION_ACTIVE) === "true"

    if (isActive) {
        channel.addEventListener("message", respondToPing)
        options.onExistingSession?.()
    } else {
        channel.addEventListener("message", handleResponse)
        channel.postMessage({ type: "PING" })

        setTimeout(() => {
            channel.removeEventListener("message", handleResponse)

            if (!received) {
                sessionStorage.setItem(CROSS_TAB_SESSION_ACTIVE, "true")
                options.onNewSession?.()
            }

            channel.addEventListener("message", respondToPing)
        }, RESPONSE_TIMEOUT)
    }

    return () => {
        channel.close()
        channel.removeEventListener("message", handleResponse)
        channel.removeEventListener("message", respondToPing)
    }
}
